import { render } from "./App.vue?vue&type=template&id=1dff2b3c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1dff2b3c&lang=css"
script.render = render

export default script